import { GameConstants } from "../GameConstants";
import { GameVars } from "../GameVars";
import { RectangleWithCorners } from "../utils/RectangleWithCorners";
import { GameModel } from "../GameModel";
import { AudioManager } from "../AudioManager";

export class HelpLayer extends Phaser.Group {

    constructor(game: Phaser.Game) {

        super(game, null, "help-layer");

        const scaledItems = new Phaser.Group(this.game);
        scaledItems.x = GameConstants.GAME_WIDTH / 2;
        this.add(scaledItems);
        
        scaledItems.scale.x = GameVars.scaleX;
        
        const rectangleWidth = 820;
        
        const rectangleWithCorners = new RectangleWithCorners(this.game, 0, 170, rectangleWidth, 326, 20, "#425271", .8);
        rectangleWithCorners.x -= rectangleWidth / 2;
        scaledItems.add(rectangleWithCorners);
        
        const helpLabel = new Phaser.BitmapText(this.game, -380, 122, "beacon", "Help!", 110);
        scaledItems.add(helpLabel);
        
        const helpText = new Phaser.BitmapText(this.game, 0, 270, "marker-felt", "Move all the cards from the outer piles (tableau) to the eight\nfoundation piles below. Build the aces up in suit to the king,\nand the kings down in suit to the ace. Cards in the tableau can\nbe moved on top of one another as long as they are the same\nsuit and the card being placed is directly higher or lower in value\nas the card beneath it.", 30);
        helpText.x -= helpText.width / 2;
        scaledItems.add(helpText);
        
        const okButton = new Phaser.Button(this.game, 0, 536, "texture_atlas_1", this.onClickOK, this);
        okButton.setFrames("button-ok-on.png", "button-ok-off.png", "button-ok-on.png");
        okButton.anchor.setTo(.5, .5);
        scaledItems.add(okButton);  
    }
    
    private onClickOK(b: Phaser.Button): void {
        
        b.clearFrames();
            
        GameModel.currentInstance.onOkHelp();
        
        AudioManager.getInstance().playSound("click");
    }
}

